import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const EditorTrimIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="3" y="7" width="1" height="5" rx="0.5" fill={fillColor || '#B8BDC1'} />
      <rect x="3" y="13" width="1" height="5" rx="0.5" fill={fillColor || '#B8BDC1'} />
      <rect x="17" y="7" width="1" height="5" rx="0.5" fill={fillColor || '#B8BDC1'} />
      <rect x="17" y="13" width="1" height="5" rx="0.5" fill={fillColor || '#B8BDC1'} />
      <circle cx="1.5" cy="1.5" r="1" transform="matrix(1 0 0 -1 2 14)" stroke="#B8BDC1" />
      <circle cx="0.5" cy="0.5" r="0.5" transform="matrix(1 0 0 -1 6 13)" fill={fillColor || '#B8BDC1'} />
      <circle cx="0.5" cy="0.5" r="0.5" transform="matrix(1 0 0 -1 8 13)" fill={fillColor || '#B8BDC1'} />
      <circle cx="0.5" cy="0.5" r="0.5" transform="matrix(1 0 0 -1 10 13)" fill={fillColor || '#B8BDC1'} />
      <circle cx="0.5" cy="0.5" r="0.5" transform="matrix(1 0 0 -1 12 13)" fill={fillColor || '#B8BDC1'} />
      <circle cx="0.5" cy="0.5" r="0.5" transform="matrix(1 0 0 -1 14 13)" fill={fillColor || '#B8BDC1'} />
      <circle cx="1.5" cy="1.5" r="1" transform="matrix(1 0 0 -1 16 14)" stroke="#B8BDC1" />
    </svg>
  );
};

export { EditorTrimIcon };
